import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import SiteFooter from './SiteFooter';
import Drawer from './Drawer';

const MainLayout = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(window.scrollY > 50);

  const handleMenuClick = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={isDrawerOpen ? 'menu-open' : ''}>
      <Header onMenuClick={handleMenuClick} scrolled={scrolled} />
      <Drawer isOpen={isDrawerOpen} onClose={handleDrawerClose} />
      <main id="main-content">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
};

export default MainLayout;
